import { RE2JS } from "re2js";

/**
 * Re2正規表現のエラーメッセージを取得する関数
 *
 * @param pattern 検証する正規表現パターン
 * @returns エラーメッセージ。有効な正規表現の場合はnull
 */
export function getRe2RegexError(pattern: string): string | null {
  try {
    RE2JS.compile(pattern);
    return null;
  } catch (error) {
    return error instanceof Error ? error.message : "unknown error occurerd";
  }
}

/**
 * RE2JS で値の一部に一致するかを判定し、case 感度はパターンに従います。
 * 既定では大文字・小文字を区別し、inline flag を指定した場合はその設定を適用します。
 * 不正なパターンは編集中のプレビューを成立させないため false として扱います。
 */
export function containsRe2PatternMatch(
  pattern: string,
  value: string,
): boolean {
  try {
    return RE2JS.compile(pattern).test(value);
  } catch {
    return false;
  }
}
